"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActions = void 0;
var constants_1 = require("../../constants");
var server_1 = require("../../helpers/server");
var index_1 = require("../../model/index");
var UserActions = /** @class */ (function () {
    function UserActions() {
    }
    UserActions.clearUsers = function () {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                dispatch({ type: UserActions.CLEAR_USERS });
                return [2 /*return*/];
            });
        }); };
    };
    UserActions.searchUsers = function (searchParams, gpsLossOnly) {
        var _this = this;
        if (gpsLossOnly === void 0) { gpsLossOnly = false; }
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var params, extraUri, payload, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.GET_USERS).request, payload: null,
                        });
                        params = __assign({}, (0, index_1.searchParamsToServer)(searchParams));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        extraUri = gpsLossOnly ? '/lostgps' : '';
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.USERS_URI + extraUri, params)];
                    case 2:
                        payload = _a.sent();
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.GET_USERS).success,
                            payload: __assign(__assign({}, payload), { page: (searchParams === null || searchParams === void 0 ? void 0 : searchParams.page) || 0 }),
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.GET_USERS).fail,
                            payload: error_1,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    UserActions.update = function (userId, user) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var entity, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.UPDATE_API).request,
                            payload: user,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!!userId) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.USERS_URI, __assign({}, user))];
                    case 2:
                        entity = (_a.sent()).entity;
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.UPDATE_API).success,
                            payload: entity,
                        });
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, (0, server_1.put)(constants_1.API.USERS_URI, userId, __assign({}, user))];
                    case 4:
                        _a.sent();
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.UPDATE_API, 'PUT').success,
                            payload: __assign(__assign({}, user), { _id: userId }),
                        });
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_2 = _a.sent();
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.UPDATE_API).fail,
                            payload: error_2,
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
    };
    UserActions.loadCompanies = function () {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var results, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.COMPANIES_API).request,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.COMPANIES_URI, {})];
                    case 2:
                        results = (_a.sent()).results;
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.COMPANIES_API).success,
                            payload: results,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        dispatch({
                            type: (0, server_1.apiActions)(UserActions.COMPANIES_API).fail,
                            payload: error_3,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    UserActions.checkEmailExists = function (email) {
        var _this = this;
        return function (_dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var exists, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, server_1.get)("".concat(constants_1.API.USERS_URI, "/check-email"), { email: email })];
                    case 1:
                        exists = (_a.sent()).exists;
                        return [2 /*return*/, exists];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    };
    UserActions.GET_USERS = 'GET_USER_DATA';
    UserActions.COMPANIES_API = 'GET_COMPANIES_LIST';
    UserActions.UPDATE_API = 'UPDATE_USER';
    UserActions.CLEAR_USERS = 'CLEAR_USERS';
    return UserActions;
}());
exports.UserActions = UserActions;
